<template>
  <div class="noapply">
    <!-- <img src="@/assets/images/policy/apply_kunming.png" alt="" class="banner" /> -->
    <div style="width: 100%">
      <div class="noapply-title m_t45">{{ detailsData.name }}</div>
      <div class="noapply-branch m_t20">
        责任部门：{{ detailsData.dicTranslate.departmentId }}
      </div>
      <div class="noapply-banner-wrapper m_t30">
        <div
          class="noapply-banner"
          v-for="banner in bannerList"
          :key="banner.ref"
        >
          <div class="noapply-banner-title m_t30 m_b30 font-bold">
            {{ banner.label }}
          </div>

          <div class="noapply-banner-content">
            <template v-if="banner.ref === 'policyName'">
              <div class="color_blue pointer p_l60" @click="goPolicy">
                {{ banner.value }}
              </div>
            </template>
            <template v-else-if="banner.ref === 'content'">
              <div class="pointer p_l60">
                <div v-html="banner.value"></div>
              </div>
            </template>
            <template v-else-if="banner.ref === 'bank'">
              <div
                class="banner-form m_t30"
                style="display: flex;align-items: center;justify-content: center;"
              >
                <div class="banner-form-content">
                  <el-form
                    @submit.native.prevent
                    :rules="rules"
                    ref="formBank"
                    :model="bankForm"
                  >
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="账户名" prop="accountName">
                          <el-input
                            v-model="bankForm.accountName"
                            readonly
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="账号" prop="accountNumber">
                          <el-input
                            v-model="bankForm.accountNumber"
                            readonly
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <div style="width: 100%">
                          <el-form-item label="开户银行" prop="bankName">
                            <el-input
                              v-model="bankForm.bankName"
                              readonly
                            ></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="联系人" prop="contacts">
                          <el-input
                            v-model="bankForm.contacts"
                            readonly
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="联系电话" prop="contactsPhone">
                          <el-input
                            v-model="bankForm.contactsPhone"
                            readonly
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="会计负责人" prop="accounting">
                          <el-input
                            v-model="bankForm.accounting"
                            readonly
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="出纳负责人" prop="cashier">
                          <el-input
                            v-model="bankForm.cashier"
                            readonly
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </template>

            <template v-else-if="banner.ref === 'promise'">
              <div class="p_l20">
                <el-checkbox v-model="checked2" disabled>
                  阅读并同意
                  <el-button type="text" @click="showPromise2">
                    《数据采集使用授权书》
                  </el-button>
                </el-checkbox>
              </div>
            </template>
            <template v-else-if="banner.ref === 'promise2'">
              <div class="p_l20">
                <el-checkbox v-model="checked" disabled>
                  阅读并同意
                  <el-button type="text" @click="showPromise">
                    《信用承诺书》
                  </el-button>
                </el-checkbox>
              </div>
            </template>
            <template v-else>
              <div class="p_l60">{{ banner.value }}</div>
            </template>
          </div>
        </div>
      </div>
      <div class="deal-btn">
        <!--  <el-button type="primary" @click="sureBtn">
          确认兑现
        </el-button>
        <el-button
          @click="
            $router.push({
              name: 'PcmNoApply',
            })
          "
        >
          放弃兑现
        </el-button> -->
        <el-button type="primary" @click="$router.push('/unit/ApplyNo')">
          返回
        </el-button>
      </div>
    </div>
    <!-- 数据采集使用授权 -->
    <el-dialog
      v-if="promiseVisible2"
      class="dialog"
      :visible.sync="promiseVisible2"
      @close="handleClosePromise2"
      width="60%"
      :before-close="handleClosePromise2"
    >
      <template #title>
        <div class="tc font-20">数据采集使用授权</div>
      </template>
      <div
        class="wrapper"
        style="font-size: 1.125rem;color: #505050;line-height: 3;"
      >
        <div>
          为维护授权企业合法权益，请在在授权委托书前，仔细阅读各条款，了解授权企业在本授权的权利、义务。
        </div>
        <div>
          一、授权企业采集本企业如下信息：
          <p>
            （一）企业基本信息、经营信息、财务信息、税务信息、金融信息、水电气信息、各类负面信息等企业向相关部门和单位提供的及相关部门和单位在履职、提供服务中产生的信息；
          </p>
          <p>
            （二）企业的董事、监事、高级管理人员与其履行职务相关的信息；
          </p>
          <p>
            （三）国家法律、行政法规、部门规章、地方性法规未禁止采集的与授权企业有关的其他信息。
          </p>
        </div>
        <div>
          二、授权企业在此授权采集方可以从国家机关、政府部门、事业单位、金融机构等相关部门和单位采集上述信息（包括所有历史信息及更新信息），也可从行业协会、社会团体、互联网信息平台渠道、第三方机构等取得上述信息。授权企业在此授权上述有关部门和单位向采集方提供本企业上述信息。
        </div>
        <div>
          三、授权企业在此承诺国家机关、政府部门、事业单位等部门和单位因行政管理、公共服务的需要，可以直接查询企业的上述信息，采集方可向上述部门和单位提供上述信息。
        </div>
        <div>
          四、授权企业同意授权有效期自授权企业确认本授权承诺之日起至被授权人相关所有业务终结之日止。
        </div>
        <div>
          五、本授权自授权签订之日起生效，信息采集期限为长期，以授权企业提交授权书之日为授权生效日。
        </div>
        <div>
          六、如需终止本授权，授权企业需提供相关资料，满足终止授权条件的可以终止。
        </div>
        <div>
          七、授权企业在此声明已知悉并理解本授权，以及因采集和提供非公开信息及负面信息可能导致的任何不利后果。
        </div>
        <div>
          八、若本企业与被授权人发生纠纷，应友好协商，协商不成提交仲裁委员会仲裁解决
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePromise2()">取 消</el-button>
        <el-button
          type="primary"
          @click="
            handleClosePromise2();
            checked2 = true;
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 信用承诺书 -->
    <el-dialog
      v-if="promiseVisible"
      class="dialog"
      :visible.sync="promiseVisible"
      @close="handleClosePromise"
      width="60%"
      :before-close="handleClosePromise"
    >
      <template #title>
        <div class="tc font-20">信用承诺书</div>
      </template>
      <div class="wrapper">
        <!-- <div class="font-bold font-16">本公司承诺:</div> -->
        <!-- <div class="font-16 m_t20 lh1_5">
					&nbsp;&nbsp;我公司（单位）不属于失信被执行人、联合惩戒、重大税收违反对象；企业及法定代表人从未参与涉黑涉恶违法犯罪。如若违反以上承诺，我公司（单位）愿意承担由此造成的一切法律责任。我公司（单位）授权并统一市工业和信息化局查询我公司（单位）申报本次扶持政策所需要的信用报告等相关资信情况
        </div>-->
        <div class="font-16 m_t10 lh_2 indent_2">
          为加快推进全国，加强企业诚信自律，逐步建立企业诚信经营长效机制，营造诚实守信的信用环境，树立诚信守法经营形象。我单位
          <span class="under-line">{{ basicInfo.name }}</span>
          ，统一社会信用代码为
          <span class="under-line">{{ basicInfo.property1 }}</span>
          ，郑重承诺如下：
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （一）严格遵守国家法律、法规、规章和政策规定，依法从事生产经营活动。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （二）自觉接受政府、行业组织、社会公众、新闻舆论的监督，积极履行社会责任。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （三）自我约束、自我管理，守合同、重信用，不制假售假、商标侵权、虚假宣传、违约毁约、恶意逃债、偷税漏税、价格欺诈、垄断和不正当竞争，切实维护消费者的合法权益。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （四）发生违法失信行为，依照有关法律、行政法规规定接受行政执法部门给予的行政处罚、约束和惩戒，并依法承担相应责任。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （五）本《信用承诺书》同意向社会公开。
        </div>
        <div class="footer-box m_t20">
          <div class="flex-end end-box">
            <div class="font-16 m_t10 lh1_5 flex-width">
              <span>承诺单位：</span>
              <span class="text-box">{{ basicInfo.name }}</span>
            </div>
          </div>
          <div class="flex-end end-box">
            <div class="font-16 m_t10 lh1_5 flex-width">
              <span>法定代表人：</span>
              <span class="text-box">{{ basicInfo.legal_person_name }}</span>
            </div>
          </div>

          <div class="font-16 m_t10 lh1_5">2021年12月13日</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePromise()">取 消</el-button>
        <el-button
          type="primary"
          @click="
            handleClosePromise();
            checked = true;
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getById, getBankAccount, fulfill } from "@/api/noApply";
import { FormValid } from "@/config";

export default {
  data() {
    return {
      checked: true,
      checked2: true,
      currentData: {},
      bannerList: [
        {
          ref: "policyName",
          label: "政策依据",
          value:
            "关于2022年度第一批北京市国家高新技术企业认定奖补资金项目申报的通知",
          link:
            "https://zhengshangtong.sic-credit.com/#/pcm/policyDetail?policyId=2633dc6183b94e149b5b99ca1845b0be",
        },
        {
          ref: "content",
          label: "兑现标准",
          value: "对上年度通过认定的高新技术企业每家给予一次性20万元财政奖励。",
        },
        { ref: "sale", label: "金额", value: "最高获得100,000元" },
        { ref: "bank", label: "企业银行账号信息", value: "" },
        { ref: "promise", label: "承诺函" },
      ],
      promiseVisible: false,
      promiseVisible2: false,
      basicInfo: {},
      detailsData: {
        dicTranslate: {},
      },
      bankForm: {
        accountName: "中投国信（北京）科技发展有限公司",
        accountNumber: "11102938393930",
        bankName: "中国工商银行(黄石天津路支行)",
        contacts: "鞠庆煌",
        contactsPhone: "13876547464",
        accounting: "鞠庆煌",
        cashier: "卢明江",
      },
      rules: {
        cashier: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 20,
          },
        ],
        accounting: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 20,
          },
          { validator: FormValid.name },
        ],
        contactsPhone: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 13,
          },
          { validator: FormValid.phone },
        ],
        contacts: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 20,
          },
          { validator: FormValid.name },
        ],
        bankName: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        accountNumber: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 20,
          },
          { validator: FormValid.number },
        ],
        accountName: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    // this.basicInfo = JSON.parse(localStorage.getItem("basic"));
    // this.bankForm.accountName = this.basicInfo.nickName;
    this.getData();
  },
  methods: {
    showPromise() {
      this.promiseVisible = true;
    },
    handleClosePromise() {
      this.promiseVisible = false;
    },
    showPromise2() {
      this.promiseVisible2 = true;
    },
    handleClosePromise2() {
      this.promiseVisible2 = false;
    },
    sureBtn() {
      if (!this.checked) {
        this.$message({
          message: "请先阅读并同意信用承诺书",
          type: "warning",
        });
        return;
      }

      if (!this.checked2) {
        this.$message({
          message: "请先阅读并同意数据采集使用授权书",
          type: "warning",
        });
        return;
      }
      this.$refs.formBank[0].validate((valid) => {
        if (valid) {
          fulfill({
            bankAccount: this.bankForm,
            enjoyId: this.$route.query.id,
          }).then((res) => {
            console.log(res);
            const { code, result, message } = res.data;
            if (code === 200) {
              this.$message({
                message: "兑现成功",
                type: "success",
              });
              // 跳转首页
              // this.$router.push({ name: "PcmHome" });
            } else {
              return this.$message.warning(message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getData() {
      getById({
        id: this.$route.query.enjoyId,
      })
        .then((res) => {
          let { code, result, msg } = res.data;
          this.detailsData = result;
          if (code === 200) {
            this.bannerList = [
              {
                ref: "policyName",
                label: "政策依据",
                value: result.dicTranslate.policyId,
                link:
                  "https://zhengshangtong.sic-credit.com/#/pcm/policyDetail?policyId=2633dc6183b94e149b5b99ca1845b0be",
              },
              {
                ref: "content",
                label: "兑现标准",
                value: result.standard,
              },
              {
                ref: "sale",
                label: "金额",
                value: "最高获得" + result.amount + "元",
              },
              {
                ref: "time",
                label: "兑现日期",
                value: result.releaseTime + "至" + result.closingTime,
              },
              { ref: "bank", label: "企业银行账号信息", value: "" },
              /* { ref: "promise", label: "数据采集使用授权" },
              { ref: "promise2", label: "承诺函" }, */
            ];
          }
        })
        .finally(() => (this.loading = false));
      getBankAccount({
        userCodeId: this.$route.query.id,
      })
        .then((res) => {
          let { code, result, msg } = res.data;
          if (code === 200) {
            if (result.amount == 0) {
              result.amount = "--";
            }
            // this.basicInfo = result;
            this.bankForm = result;
          }
        })
        .finally(() => (this.loading = false));
    },
    goPolicy() {
      // this.$router.push({
      //   path: "/pcm/policyDetail",
      //   query: { publicyId: this.detailsData.policyId },
      // });
	  const url = `/#/pcm/policyDetail?publicyId=`+this.detailsData.policyId;
	  window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__content,
/deep/.el-form-item__label {
  font-size: 16px;
}
.banner-form {
  border: 1px solid #eee;
  min-height: 260px;
  &-label {
    display: flex;
    background: #f6f8fa;
    color: #333;
    font-weight: bold;
    padding: 10px 20px;
    border: 1px solid #eee;
  }
  &-content {
    padding: 10px 20px 0;
  }
  &-none {
    color: #ccc;
    text-align: center;
    height: 100%;
    cursor: pointer;
    font-size: 20px;
  }
}
.noapply-title {
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin-top: 34px;
}
.noapply-branch {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #aaa;
}
.noapply-banner-title {
  position: relative;
  font-size: 18px;
  padding-left: 20px;
  font-weight: normal;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0.5px;
    width: 4px;
    height: calc(100% - 1px);
    background: $blue;
  }
}
.el-icon-check {
  color: $green;
  padding: 2px;
  border-radius: 50%;
  border: 1px solid $green;
}
/deep/ .el-dialog__body {
  padding: 20px 60px 30px;
}
/deep/ .el-dialog__footer {
  padding: 10px 60px 30px;
}
.wrapper {
  .under-line {
    display: inline-block;
    min-width: 80px;
    position: relative;
    text-indent: 0;
    margin: 0 10px;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      border: 1px solid #b1aeae;
      left: 0;
      bottom: -2px;
    }
  }
  .indent_2 {
    text-indent: 2em;
  }
  .lh_2 {
    line-height: 2;
  }
  .footer-box {
    text-align: right;
    // .text-box{
    // 	display: inline-block;
    // 	min-width: 100px;
    // }
    // .flex-end{
    // 	display: flex;
    // 	justify-content: end;
    // }
    .end-box {
      display: flex;
      justify-items: end;

      .flex-width {
        width: 42%;
        text-align: left;
        display: flex;
        .text-box {
          flex: 1;
        }
      }
    }
  }
}
.deal-btn {
  width: 290px;
  margin: 40px auto;
}
.banner {
  width: 100%;
  margin: 20px auto 30px;
}
</style>
